import { DataType } from 'src/components/formEditor/uiEditor/uiEditor';
import { UploadFilesResolveType } from './GeneralFormFillingModal.t';
import _ from 'lodash';
import { AppAttachmentValue } from 'uikit/fields/attachments/attachmentsField/appAttachmentsField';

export const injectFileIdToAnswer = (data: DataType, response: UploadFilesResolveType[]): DataType => {
  for (const { path, id } of response) {
    _.set(data, `${path}.id`, id);
  }

  return data;
};

export const normalizeFileValues = (data: DataType): DataType => {
  const fileIdWithPath = findFilesWithPaths(data);
  for (const { path } of fileIdWithPath) {
    _.unset(data, `${path}.file`);
  }

  return data;
};
export const getFileIdsToCommit = (data: DataType): string[] =>
  findFilesWithPaths(data)
    .filter((x) => !!x.id && !!x.file)
    .map((x) => x.id) as string[];

export const findFilesWithPaths = (
  data: any,
  path: string[] = [],
  result: { id: string | null; file: File; path: string }[] = [],
) => {
  if (!_.isObject(data)) return result;
  if (isAppAttachment(data) && !_.isNil(data.file))
    result.push({
      id: data.id,
      file: data.file,
      path: path.join('.'),
    });

  _.forOwn(data, (value, key) => {
    if (_.isObject(value)) findFilesWithPaths(value, [...path, key], result);
  });

  return result;
};

export const isAppAttachment = (data: any): data is AppAttachmentValue => _.has(data, 'file') && data.file !== '';
